import { PlatformType, PlatformTypeSchema } from '../schemas'
import { isWhitelabelHost } from './whitelabel'

export const getPlatformTypeForHost = (host?: string): PlatformType => {
  const isWhitelabel = isWhitelabelHost(host)
  return isWhitelabel ? PlatformTypeSchema.enum.whitelabel : PlatformTypeSchema.enum.avios
}
